import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledMultiColumnSection = styled.div.withConfig({
  displayName: "MultiColumnSection__StyledMultiColumnSection",
  componentId: "sc-1425gcm-0"
})(["@media only screen and (min-width:576px){display:table-row-group;}> div:not(:first-child){border-color:transparent;> div{border-color:transparent;}> div > span{", " margin-block-end:", ";}}", ";"], ({
  theme
}) => theme.typography['heading-100'], ({
  theme
}) => theme.space[100], ({
  $cssStyles
}) => $cssStyles);
export const MultiColumnSection = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledMultiColumnSection, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};